module.exports = __webpack_public_path__ + "static/media/400042_01.c9651545.png";